import styled from 'styled-components';
import { BorderRadiusSkeleton } from 'modules/predictiveGoals/components/Styled';
import { pxToRem } from 'utils/convert';

const SkeletonComponentsContainer = styled.div`
  display: grid;
  grid-template-columns: 30% 1fr;
  grid-template-rows: ${pxToRem(240)} ${pxToRem(400)};
  gap: ${pxToRem(48)} ${pxToRem(60)};
`;

const LeftSection = styled(BorderRadiusSkeleton)`
  grid-area: 1 / 1 / 2 / 1;
  height: ${pxToRem(320)};
`;

const TopRightSection = styled(BorderRadiusSkeleton)`
  grid-area: 1 / 2;
`;

const BottomRightSection = styled(BorderRadiusSkeleton)`
  grid-area: 2 / 2;
`;

export const ReadOnlySkeletonId = 'read-only-skeleton-loader';

export const ReadOnlyGoalSkeleton = () => {
  return (
    <SkeletonComponentsContainer data-test={ReadOnlySkeletonId}>
      <LeftSection />
      <TopRightSection />
      <BottomRightSection />
    </SkeletonComponentsContainer>
  );
};
